import { css } from '@emotion/core'
import React from 'react'

import MenuCloseIcon from '../icons/abstract/menu-close.svg'
import Image from './Image'

export interface BannerProps {
  id?: string
  message: string | React.ReactNode
  withoutCloseIcon?: boolean
}

const Banner: React.FunctionComponent<BannerProps> = ({ id, message, withoutCloseIcon }) => {
  const [visible, setVisible] = React.useState(false)
  React.useEffect(() => {
    if (loadBannerState(id) !== false) {
      setVisible(true)
    }
  }, [])
  return visible ? (
    <div css={bannerContainerStyle} className={'full-screen-relative'}>
      <div css={bannerContentStyle}>
        <Image src={'ai/stars.webp'} alt={'airfocus AI stars image'} />
        <div css={messageStyle}>{message}</div>
        <Image src={'ai/stars.webp'} alt={'airfocus AI stars image'} />
      </div>
      {!withoutCloseIcon && (
        <MenuCloseIcon
          css={menuOpenCloseIconStyle}
          onClick={() => {
            saveBannerState(id)
            setVisible(false)
          }}
        />
      )}
    </div>
  ) : null
}

export default Banner

function loadBannerState(id?: string) {
  try {
    if (!id) {
      return true
    }
    const stored = window.localStorage.getItem(`show-banner-${id}`)
    switch (stored) {
      case 'true':
        return true
      case 'false':
        return false
      default:
        return undefined
    }
  } catch {
    return undefined
  }
}

function saveBannerState(id?: string) {
  try {
    if (!!id) {
      return window.localStorage.setItem(`show-banner-${id}`, false.toString())
    }
  } catch {
    return undefined
  }
}

const bannerContainerStyle = css`
  z-index: 1;
  display: grid;
  grid-gap: 20px;
  align-items: center;
  justify-content: flex-start;
  grid-template-columns: 1fr auto;
  /* background: linear-gradient(90deg, #1881ff, #b3b8fe); */
  background-color: #318eff;
  padding: 1rem 0;
  position: relative;

  // stars images for AI banner
  .gatsby-image-wrapper {
    width: 1.5rem;
  }
`

const bannerContentStyle = css`
  display: flex;
  justify-content: center;
  gap: 2rem;
`

const messageStyle = css`
  grid-row: 1;
  grid-column: 1;
  text-align: left;
  color: #fff;

  a {
    color: #fff;
    white-space: nowrap;
  }
`

const menuOpenCloseIconStyle = css`
  width: 20px;
  height: 20px;
  cursor: pointer;
  flex-shrink: 0;
  flex-grow: 0;

  path {
    stroke: #fff !important;
  }

  &:hover {
    opacity: 0.65;
  }
`
